export const filterListing = (in_data, in_priceHigh = null, in_priceLow = null, in_brandIds = null, in_refineIds = null, in_search = "", in_objectKey = null, priceKey = "member_price") => {
    if (!in_data) {
        return []
    }

    let brandIds = null
    let refineIds = null
    let search = ""
    let priceFilter = null
    let priceHigh = parseFloat(in_priceHigh || Infinity)
    let priceLow = parseFloat(in_priceLow || 0)

    //setup refine id
    if (in_refineIds && !Array.isArray(in_refineIds)) {
        refineIds = in_refineIds.split(",");
    }

    if (in_brandIds && !Array.isArray(in_brandIds)) {
        brandIds = in_brandIds.split(",");
    }

    if (in_search) {
        search = in_search.toLowerCase()
    }

    if (priceHigh && priceLow) {
        priceFilter = (price) => price > priceLow && price < priceHigh
    }

    return in_data.filter(item => {
        let product = item
        let inTitle = false;
        let inKeywords = false;
        let inProductCode = false;
        let inRefineCat = true;
        let inBrand = true;
        let inPriceRange = true;

        if (in_objectKey) {
            if(!(in_objectKey in item)){
                console.error(in_objectKey, " not found in item ", item)
            }
            product = item[in_objectKey]
        }

        //check for filter by search
        try{
            inTitle = product.title.toLowerCase().includes(search);
            inKeywords = product.keywords.toLowerCase().includes(search);
            inProductCode = product.product_code.toLowerCase().includes(search);
        }catch (e){
            // console.log("no title or keywords")
        }

        //Check in refinements
        if (refineIds && refineIds.length > 0) {
            inRefineCat = product.categories.some(r => refineIds.includes(r));
        }

        if (brandIds && brandIds.length > 0) {
            inBrand = brandIds.includes(product.brand_id_fk);
        }

        //Check price within range

        if (priceFilter) {
            let price = product[priceKey].price || product[priceKey]; //TODO remove this hack
            inPriceRange = priceFilter(price)
        }

        return (
            inBrand && inRefineCat && (inTitle || inKeywords || inProductCode) && inPriceRange
        );
    })
}
